import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { FormToggle } from "@/components/form/FormToggle";
import { Icon } from "@/components/icons/Icon";

import type { GroupNodeModel } from "@/models/nodes/GroupNodeModel";

type Props = {
  node: GroupNodeModel;
};

export const CasesSystemToggler = observer(function CasesSystemToggler({ node }: Props) {
  const t = useTranslations("sidebar.activeNode.group");

  const handleOnToggleChange = () => {
    const { doc, matrixNode } = node;

    doc.transact(() => {
      const casesSystemEnabled = !node.casesSystemEnabled;
      node.casesSystemEnabled = casesSystemEnabled;

      if (!casesSystemEnabled) {
        return;
      }

      if (matrixNode && matrixNode.rows === 1) {
        node.matrixNode?.appendRow();
      }
    }, "group:toggleCasesSystem");

    doc.focus();
  };

  return (
    <label
      htmlFor="cases-system"
      aria-label={t("title.casesSystem")}
      className="flex items-center text-xs tracking-tight py-1.25"
    >
      <Icon name="math/CasesSystem" className="mr-1" />
      {t("title.casesSystem")}
      <FormToggle
        id="cases-system"
        checked={!!node.casesSystemEnabled}
        className="ml-auto"
        onClick={(e) => e.stopPropagation()}
        onChange={handleOnToggleChange}
        asInput
      />
    </label>
  );
});
